import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/apiClient";
import { Package, Receipt, Bicycle, Wrench, EnvelopeSimple, Users, TrendUp } from "@phosphor-icons/react";

function StatCard({ icon: Icon, label, value, sub, testId, color = "orange" }) {
  return (
    <div className="bg-white border border-neutral-200 p-6" data-testid={testId}>
      <div className={`inline-flex items-center justify-center w-10 h-10 mb-4 ${color === "orange" ? "bg-[color:var(--vt-orange)]/10 text-[color:var(--vt-orange)]" : "bg-black/5 text-black"}`}>
        <Icon size={22} weight="duotone" />
      </div>
      <div className="overline text-neutral-500 mb-1">{label}</div>
      <div className="font-display font-black text-3xl">{value}</div>
      {sub && <div className="text-xs text-neutral-500 mt-1">{sub}</div>}
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="p-12 text-neutral-500">Loading dashboard…</div>;

  return (
    <div className="p-8 lg:p-12" data-testid="admin-dashboard">
      <div className="mb-10">
        <div className="overline text-[color:var(--vt-orange)] mb-2">/ OVERVIEW</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Dashboard</h1>
        <p className="text-neutral-500 text-sm mt-2">Welcome back. Here's what's happening at VELOTEKA today.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard testId="stat-revenue" icon={TrendUp} label="Total Revenue" value={`€${(stats.revenue_orders + stats.revenue_rentals).toFixed(2)}`} sub={`€${stats.revenue_orders.toFixed(2)} shop · €${stats.revenue_rentals.toFixed(2)} rental`} />
        <StatCard testId="stat-orders" icon={Receipt} label="Orders" value={stats.orders} color="black" />
        <StatCard testId="stat-rentals" icon={Bicycle} label="Rentals" value={stats.rentals} color="black" />
        <StatCard testId="stat-services" icon={Wrench} label="Service Requests" value={stats.services} color="black" />
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        <StatCard testId="stat-products" icon={Package} label="Products" value={stats.products} color="black" />
        <StatCard testId="stat-users" icon={Users} label="Customers" value={stats.users} color="black" />
        <StatCard testId="stat-newsletter" icon={EnvelopeSimple} label="Newsletter" value={stats.newsletter} color="black" />
        <StatCard testId="stat-contacts" icon={EnvelopeSimple} label="Messages" value={stats.contacts} color="black" />
      </div>

      <div className="bg-white border border-neutral-200 p-6">
        <h2 className="font-display font-bold text-xl mb-4">Quick Actions</h2>
        <div className="flex flex-wrap gap-3">
          <Link to="/admin/products" className="vt-btn-orange text-xs">+ Add / Manage Products</Link>
          <Link to="/admin/orders" className="vt-btn-outline text-xs">View Orders</Link>
          <Link to="/admin/rentals" className="vt-btn-outline text-xs">Manage Rentals</Link>
        </div>
      </div>
    </div>
  );
}
